import React, { useState, useEffect } from "react";
import { getActividades, getTrabajadores } from "../../services/apis";
import {
	Box,
	Grid,
	Paper,
	Stack,
	Typography,
	Chip,
	Button,
} from "@mui/material";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import LockIcon from "@mui/icons-material/Lock";
import AddIcon from "@mui/icons-material/Add";
import { ActividadCard } from "./ActividadCard";
import { CrearActividadDialog } from "./CrearActividadDialog";
import { AlertSuccess } from "../../utils/componentes-utiles/AlertError";

const invitadosValor = (invitados, clave) => {
	return invitados?.[clave] || invitados?.[clave.replace("nino", "niño")] || invitados?.[clave.replace("nino", "niÃ±o")] || 0;
};

const contarAsistentes = (actividad) => {
	return (actividad.asistentes || []).reduce((acc, asistente) => {
		const invitados = asistente.invitados || {};
		return acc + (Number(asistente.miembro_asiste ?? 1) === 1 ? 1 : 0) + invitadosValor(invitados, "invitados") + invitadosValor(invitados, "invitados_nino1") + invitadosValor(invitados, "invitados_nino2");
	}, 0);
};

const formatoFecha = (fecha) => {
	if (!fecha) return "Sin fecha";
	return new Date(fecha).toLocaleDateString("ca-ES", {
		weekday: "long",
		day: "2-digit",
		month: "long",
	});
};

export const Actividades = () => {
	const [actividades, setActividades] = useState([]);
	const [opTrabajadores, setOpTrabajadores] = useState([]);
	const [succesCrearComida, setSuccesCrearComida] = useState(null);
	const [crearActividadOpen, setCrearActividadOpen] = useState(false);

	const cargarActividades = async () => {
		try {
			const response = await getActividades();
			if (response.success) {
				setActividades(response.data);
			} else {
				console.error("Error al cargar las actividades:", response.error);
			}
		} catch (error) {
			console.error("Error en la solicitud:", error);
		}
	};

	const cargarTrabajadores = async () => {
		try {
			const response = await getTrabajadores();
			const tmp = [...response.data];
			const newTmp = tmp.map((item) => ({
				label: item.nombre,
				value: item.id
			}));
			setOpTrabajadores(newTmp);
		} catch (error) {
			console.error("Error cargar tareas", error);
		}
	};

	useEffect(() => {
		cargarActividades();
		cargarTrabajadores();
	}, []);

	useEffect(() => {
		if (succesCrearComida) {
			cargarActividades();
		}
	}, [succesCrearComida]);

	const actividadesOrdenadas = [...actividades].sort((a, b) => {
		const fechaA = `${a.fecha || ""} ${a.hora_inicio || ""}`;
		const fechaB = `${b.fecha || ""} ${b.hora_inicio || ""}`;
		return fechaA.localeCompare(fechaB);
	});

	const actividadesPorFecha = actividadesOrdenadas.reduce((acc, actividad) => {
		const fecha = actividad.fecha || "sin-fecha";
		if (!acc[fecha]) acc[fecha] = [];
		acc[fecha].push(actividad);
		return acc;
	}, {});

	const actividadesCerradas = actividades.filter((actividad) => actividad.cerrado === 1).length;

	const handleActividadCreada = () => {
		setSuccesCrearComida(true);
		cargarActividades();
	};

	return (
		<Box className="activities-shell">
			<Paper elevation={0} className="activities-header">
				<Box className="activities-header-copy">
					<Typography className="activities-eyebrow">
						Activitats
					</Typography>
					<Typography variant="h4" className="activities-title">
						Plan de actividades
					</Typography>
				</Box>
				<Stack direction="row" className="activities-header-stats">
					<Button
						variant="contained"
						startIcon={<AddIcon />}
						className="activities-add-button"
						onClick={() => setCrearActividadOpen(true)}
					>
						Afegir
					</Button>
					<Chip icon={<LocalActivityIcon />} label={`${actividades.length} actividades`} className="activities-stat-chip" />
					<Chip icon={<LockIcon />} label={`${actividadesCerradas} cerradas`} className="activities-stat-chip" />
				</Stack>
			</Paper>

			<Stack className="activities-day-list">
				{Object.entries(actividadesPorFecha).map(([fecha, actividadesDia]) => {
					return (
						<section key={fecha} className="activities-day-section">
							<Box className="activities-day-heading">
								<Box className="activities-day-title-block">
									<EventAvailableIcon fontSize="small" />
									<Typography variant="h6" className="activities-day-title">
										{formatoFecha(fecha)}
									</Typography>
								</Box>
								<Stack direction="row" className="activities-day-meta">
									<span>{actividadesDia.length} actividades</span>
									{/* <span>{totalDia} personas</span> */}
								</Stack>
							</Box>

							<Grid container spacing={2}>
								{actividadesDia.map((actividad) => (
									<Grid key={actividad.id} size={{ xs: 12, md: 6, xl: 4 }}>
										<ActividadCard
											data={actividad}
											totalAsistentes={contarAsistentes(actividad)}
											opTrabajadores={opTrabajadores}
											setSuccesCrearComida={setSuccesCrearComida}
										/>
									</Grid>
								))}
							</Grid>
						</section>
					);
				})}
			</Stack>

			{succesCrearComida && (
				<AlertSuccess open={succesCrearComida} setOpen={setSuccesCrearComida} titulo={"Èxit"} mensaje={"Canvis realitzats amb èxit"} tipo={"success"} />
			)}
			<CrearActividadDialog
				open={crearActividadOpen}
				onClose={() => setCrearActividadOpen(false)}
				opTrabajadores={opTrabajadores}
				onCreated={handleActividadCreada}
			/>
		</Box>
	);
};
